let tween, cam;

export default class GetCoinScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'GetCoinScene',
    });
  }

  preload() {}

  animsLoad() {
    this.load.plugin('rexflashplugin', 'assets/Plugins/rexflashplugin.min.js', true);
    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexkawaseblurpipelineplugin.min.js',
      true,
    );
    this.load.multiatlas(
      'coinPile',
      'assets/G2 Game Anims/gold coin pile anim/goldCoinsPileAnim.json',
      'assets/G2 Game Anims/gold coin pile anim',
    );
    this.load.multiatlas(
      'endConfetti',
      'assets/confetti/confettiAnimNew.json',
      'assets/confetti',
    );
    this.load.multiatlas(
      'spotlight',
      'assets/spotlight/spotlightAnimNew.json',
      'assets/spotlight',
    );
  }

  create() {
    this.BG = this.add
      .image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'BG')
      .setScale(0.5);
    this.cycle = this.add.image(870, 410, 'cycle').setAlpha(0.3);
    this.coin = this.add.image(640, 570, 'coin').setAlpha(0).setVisible(false);
    cam = this.cameras.main;

    this.anims.create({
      key: 'walkIn',
      frames: this.anims.generateFrameNames('walkIn', {
        start: 0,
        end: 139,
        zeroPad: 0,
        prefix: 'CharacterWalk',
        suffix: '.png',
      }),
      frameRate: 35,
      repeat: 0,
    });

    tween = this.tweens.add({
      targets: this.cycle,
      alpha: 1.0,
      duration: 2000,
      delay: 500,
      ease: 'Power1',
      repeat: 0,
      yoyo: false,
    });

    this.walkIn = this.add.sprite(650, 350, 'walkIn').play('walkIn');

    this.walkIn.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE,
      () => {
        this.animsLoad();
        this.load.start();
        this.time.delayedCall(
          150,
          () => {
            this.coin.setVisible(true);
            this.tweens.add({
              targets: this.coin,
              alpha: 1.0,
              delay: 250,
              duration: 1000,
            });
            this.coin.setInteractive({ cursor: 'pointer' });
          },
          [],
          this,
        );
      },
      this,
    );

    this.coin.on(
      'pointerover',
      function (pointer) {
        this.coin.setTexture('coinBlack');
      },
      this,
    );

    this.coin.on(
      'pointerout',
      function (pointer) {
        this.coin.setTexture('coin');
      },
      this,
    );

    this.coin.on(
      'pointerdown',
      function (pointer) {
        this.coin.setVisible(false);
        cam.fadeOut(500, 255, 255, 255);
        cam.once(
          'camerafadeoutcomplete',
          function (camera) {
            this.scene.start('GameScene');
            // this.scene.stop("GetCoinScene");
          },
          this,
        );
      },
      this,
    );
  }

  update() {}
}
